import styled from '@emotion/styled'

import { ICalloutOffset, Pin } from '../types'
import { Priority } from './types'
import { markerHeightForPin, markerPositionOffsetForPin, markerWidthForPin } from './util'

const markerZIndexManifest: { [key in Priority]: number } = {
  [Priority.DEFAULT]: 1,
  [Priority.HIGH]: 2,
}

const zIndexManifest = {
  callout: 4,
  marker: markerZIndexManifest,
  selectedMarker: 3,
}

interface IMarkerContainerProps {
  selected: boolean
  priority: Priority
  pin: Pin
}

export const MarkerContainer = styled.div<IMarkerContainerProps>`
  display: flex;
  height: ${({ pin }) => markerHeightForPin(pin)}px;
  pointer-events: none;
  position: absolute;
  top: ${({ selected, pin }) =>
    selected ? markerPositionOffsetForPin(pin) : -markerHeightForPin(pin)}px;
  left: ${({ pin }) => -markerWidthForPin(pin) / 2}px;
  width: ${({ pin }) => markerWidthForPin(pin)}px;

  z-index: ${({ selected, priority }) =>
    selected ? zIndexManifest.selectedMarker : zIndexManifest.marker[priority]};
`

export const PinContainer = styled.div`
  margin: auto auto 0;
  pointer-events: auto;
`

interface ICalloutContainerProps {
  offset: ICalloutOffset
}

export const CalloutContainer = styled.div<ICalloutContainerProps>`
  bottom: ${({ offset }) => offset.bottom}px;
  left: ${({ offset }) => offset.left}px;
  pointer-events: auto;
  position: absolute;
  width: 370px;
  z-index: ${zIndexManifest.callout};
`
